export function parseOriginError(error) {
    return JSON.parse(error?.message)?.error;
}

export function parsePrepareError(error) {
    // TODO this is nasty but i have asked BE for more consistent errors
    const errString = error?.message;
    const noLines = errString?.replace(/\n {4}/g, '');
    const errorMessageStringStart = `"message": String(`;
    const indexOfFirstErrorStart = noLines.indexOf(errorMessageStringStart);
    const indexOfLastErrorStart = noLines.lastIndexOf(errorMessageStringStart);
    const firstErrorStart = noLines.substring(indexOfFirstErrorStart + errorMessageStringStart.length + 1);
    const firstErrorMessage = firstErrorStart.substring(0, firstErrorStart.indexOf(`"`));

    const lastErrorStart = noLines.substring(indexOfLastErrorStart + errorMessageStringStart.length + 1);
    const lastErrorMessage = lastErrorStart.substring(0, lastErrorStart.indexOf(`"`));

    return lastErrorMessage || firstErrorMessage;
}
